<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div class="canvas-panel" style="left:0">
        <v-overlay v-if="showOverlay">
            <v-col align="center">
                <div>{{ showOverlay }}</div>
                <v-progress-circular indeterminate size="64">
                    <v-btn text @click="closeOverlay()"></v-btn>
                </v-progress-circular>
            </v-col>
        </v-overlay>


        <v-layout>
            <modal name="uml-modal" :height='"80%"' :width="'80%'">
                <class-modeler></class-modeler>
            </modal>
        </v-layout>


        <v-snackbar v-model="deleteSnackbar" color="primary" multi-line :timeout="5000">
            해당 BoundedContext ( {{ deleteBounded }} )데이터가 삭제되었습니다.
            <v-btn dark @click="deleteSnackbar = false">
                Close
            </v-btn>
        </v-snackbar>


        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'"
                    :timeout="snackbar.timeout"
                    :vertical="snackbar.mode === 'vertical'" top centered>
            {{ snackbar.text }}
            <v-btn dark @click="snackbar.show = false" small style="margin-left: 10px;">
                Close
            </v-btn>
        </v-snackbar>


        <v-alert
                dense
                elevation="6"
                colored-border
                :value="alertInfo.show"
                :border="alertInfo.border"
                :type="alertInfo.type"
                :max-width="alertInfo.maxWidth"
                :color="alertInfo.color"
                width="100%"
                style="align-self: center; position: absolute; z-index:999; margin-left: 35%;"
        >
            <div style="color: black;"> {{alertInfo.text}}</div>
            <a v-if="alertInfo.link" target="_blank" :href="alertInfo.link">Github Persenal Access Token 발행 방법</a>
            <div style="text-align: right;">
                <v-btn v-if="alertInfo.submit" @click="alertSubmit(alertInfo.fnNum)" small color="green"
                       style="margin-right: 5px;" dark>
                    {{alertInfo.submit}}
                </v-btn>
                <v-btn @click="alertClose(alertInfo.fnNum)" small text>{{$t('word.close')}}</v-btn>
            </div>
        </v-alert>


        <v-layout right>
            <opengraph ref="opengraph"
                       :width=100000 :height=100000
                       :sliderLocationScale=sliderLocationScale
                       focus-canvas-on-select wheelScalable :labelEditable="true"
                       :dragPageMovable="dragPageMovable" :enableContextmenu="false" :enableRootContextmenu="false"
                       :enableHotkeyCtrlC="false" :enableHotkeyCtrlV="false"
                       :enableHotkeyDelete="false" :enableHotkeyCtrlZ="false" :enableHotkeyCtrlD="false"
                       :enableHotkeyCtrlG="false" :slider="true"
                       :movable="!getReadOnly"
                       :resizable="!getReadOnly"
                       :selectable="true"
                       :connectable="!getReadOnly"
                       v-if="value"
                       :autoSliderUpdate="true"
                       :imageBase="imageBase"
                       v-on:update:sliderLocationScale="sliderLocationScale = $event"
                       v-on:connectShape="onConnectShape"
                       v-on:canvasReady="bindEvents"
            >
                <!--  Model -->
                <div v-if="value.elements && typeof value.elements == 'object'" :key="elementId"
                        v-for="elementId in Object.keys(value.elements)">
                    <component
                            v-if="elementId && value.elements[elementId]"
                            :is="getComponentByClassName(value.elements[elementId]._type)"
                            :value.sync="value.elements[elementId]"
                            :ref="elementId"
                    ></component>
                </div>

                <div v-if=" value.relations && typeof value.relations == 'object'" :key="relationId"
                        v-for="relationId in Object.keys(value.relations)">
                    <component
                            v-if="relationId && value.relations[relationId]"
                            :is="getComponentByClassName(value.relations[relationId]._type)"
                            :value.sync="value.relations[relationId]"
                            :ref="relationId"
                    ></component>
                </div>
            </opengraph>


            <v-layout row>
                <v-flex v-if="!getReadOnly && !isHexagonalModeling">
                    <v-row style="margin-left: 70px; margin-top: 10px">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn :disabled="checkUndo" text small right @click.native="undo()"
                                       v-on="on">
                                    <v-icon medium>mdi-undo</v-icon>
                                </v-btn>
                            </template>
                            <span>Undo</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn :disabled="checkRedo" text small right @click.native="redo()"
                                       v-on="on">
                                    <v-icon medium>mdi-redo</v-icon>
                                </v-btn>
                            </template>
                            <span>Redo</span>
                        </v-tooltip>
                    </v-row>
                </v-flex>


                <slot name="top">
                    <v-flex style="justify:end; align:start;">
                        <v-row style="margin-right:10px;">
                            <v-row justify="end" align="start" style="margin-right: 5px; margin-top:15px;">
                                <slot name="projectName">
                                    <v-col align="start" justify="end" cols="5" md="5" sm="5" id="project-name">
                                        <v-text-field
                                                :disabled="getReadOnly || (fullPath && fullPath.includes('replay')) "
                                                :color="projectNameColor"
                                                :error-messages="projectNameHint"
                                                label="Project Name" v-model="projectName"
                                                @click.native="unselectedAll">
                                        </v-text-field>
                                    </v-col>
                                </slot>
                            </v-row>
                            <div>
                                <div v-if="isMobile">
                                    <v-card id="mobile-menu-popup-btn">
                                        <v-speed-dial
                                                v-model="fab"
                                                right
                                                bottom
                                        >
                                            <template v-slot:activator>
                                                <v-btn
                                                        v-model="fab"
                                                        color="blue darken-2"
                                                        dark
                                                        fab
                                                        small
                                                >
                                                    <v-icon v-if="fab">
                                                        mdi-playlist-remove
                                                    </v-icon>
                                                    <v-icon v-else>
                                                        mdi-playlist-check
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <v-row id="mobile-action-btn" justify="end" align="start"
                                                   style="margin-right: 10px;">
                                                <slot name="saveButton">
                                                    <v-menu
                                                            open-on-hover
                                                            offset-y
                                                    >
                                                        <template v-slot:activator="{ on }">

                                                            <v-btn
                                                                    text
                                                                    v-if="getReadOnly"
                                                                    :color="joinRequestedText.show ? 'primary' :'success'"
                                                                    dark
                                                                    @click="requestInviteUser()"
                                                                    small
                                                            >
                                                                <div v-if="joinRequestedText.show">
                                                                    <v-icon>{{icon.join}}</v-icon>
                                                                </div>
                                                                {{ joinRequestedText.text }}
                                                            </v-btn>

                                                            <v-btn
                                                                    text
                                                                    v-if="getReadOnly"
                                                                    color="primary"
                                                                    dark
                                                                    @click="saveComposition('fork')"
                                                                    small
                                                            >
                                                                <v-icon>{{icon.fork}}</v-icon>
                                                                FORK
                                                            </v-btn>
                                                            <v-btn
                                                                    text
                                                                    v-else
                                                                    color="primary"
                                                                    dark
                                                                    @click="saveComposition('save')"
                                                                    v-on="on"
                                                                    small
                                                            >
                                                                <v-icon>{{icon.save}}</v-icon>
                                                                SAVE
                                                            </v-btn>
                                                        </template>
                                                        <v-list>
                                                            <v-list-item
                                                                    v-if="!isClazzModeling"
                                                                    v-for="(item, index) in saveItems"
                                                                    :key="index"
                                                                    @click="functionSelect(item.title,index)"
                                                            >
                                                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </slot>


                                                <slot name="shareButton">
                                                    <v-menu
                                                            v-if="isMineProject && isServerModeling && !getReadOnly "
                                                            class="pa-2"
                                                            offset-y
                                                            open-on-hover
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <div>
                                                                <v-btn
                                                                        text
                                                                        color="primary"
                                                                        dark
                                                                        v-on="on"
                                                                        @click="openInviteUsers()"
                                                                        small
                                                                >
                                                                    <v-icon>{{icon.share}}</v-icon>
                                                                    SHARE
                                                                    <v-avatar v-if="requestCount" size="25" color="red"
                                                                              style="margin-left: 2px;"> {{ requestCount
                                                                        }}
                                                                    </v-avatar>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <v-list>
                                                            <v-list-item
                                                                    v-for="(item, index) in shareItems"
                                                                    :key="index"
                                                                    @click="functionSelect(item.title,index)"
                                                            >
                                                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </slot>
                                                <slot name="versionButton">
                                                    <v-menu
                                                            text
                                                            v-if="isServerModeling && !isClazzModeling"
                                                            class="pa-2"
                                                            open-on-hover
                                                            offset-y>
                                                        <template v-slot:activator="{ on }">
                                                            <div>
                                                                <v-btn
                                                                        color="primary"
                                                                        dark
                                                                        @click='showReplay()'
                                                                        small
                                                                        :disabled="disableBtn"
                                                                        text
                                                                >
                                                                    <v-icon>mdi-restart</v-icon>
                                                                    Replay
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-menu>
                                                </slot>
                                                <!-- <slot name="codeButton">
                                                    <v-menu
                                                            open-on-hover
                                                            offset-y>
                                                        <template v-slot:activator="{ on }">
                                                            <div>
                                                                <v-btn
                                                                        text
                                                                        color="orange"
                                                                        dark
                                                                        @click="codeModalShow()"
                                                                        v-on="on"
                                                                        small
                                                                >
                                                                    <v-icon> {{ icon.code}}</v-icon>
                                                                    CODE
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <v-list>
                                                            <v-list-item
                                                                    v-for="(item, index) in codeItems"
                                                                    :key="index"
                                                                    @click="functionSelect(item.title,index)"
                                                            >
                                                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </slot> -->
                                            </v-row>

                                        </v-speed-dial>
                                    </v-card>
                                </div>

                                <div v-else>
                                    <v-row id="action-btn" justify="end" align="start" style="margin-right: 15px; margin-top: 15px;">
                                        <!-- <slot name="hexagonalButton">
                                            <v-menu
                                                    class="pa-2"
                                                    open-on-hover
                                                    offset-y
                                                    left
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <div>
                                                        <v-btn
                                                                v-if="isHexagonalModeling"
                                                                text
                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                color="primary"
                                                                @click='generateModel()'
                                                                :disabled="disableBtn"
                                                        >
                                                            <v-icon>mdi-checkbox-multiple-blank-outline</v-icon>
                                                            Model
                                                        </v-btn>
                                                        <v-btn
                                                                v-else
                                                                text
                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                color="primary"
                                                                @click='generateHexagonal()'
                                                                :disabled="disableBtn"
                                                        >
                                                            <v-icon>mdi-hexagon-outline</v-icon>
                                                            Hexagonal
                                                        </v-btn>
                                                    </div>
                                                </template>
                                            </v-menu>
                                        </slot> -->
                                        <slot name="versionButton">
                                            <v-menu
                                                    v-if="isServerModeling && !isClazzModeling"
                                                    class="pa-2"
                                                    open-on-hover
                                                    offset-y
                                                    left
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <div>
                                                        <v-btn
                                                                text
                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                color="primary"
                                                                @click='showReplay()'
                                                                :disabled="disableBtn"
                                                        >
                                                            <v-icon>mdi-restart</v-icon>
                                                            Replay
                                                        </v-btn>
                                                    </div>
                                                </template>
                                            </v-menu>
                                        </slot>

                                        <slot name="saveButton">
                                            <v-menu
                                                    class="pa-2"
                                                    open-on-hover
                                                    offset-y
                                                    left
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <div v-if="getReadOnly">
                                                        <v-btn
                                                                text
                                                                color="primary"
                                                                :disabled="disableBtn"
                                                                @click="saveComposition('fork')"
                                                                style="margin-right: 5px; margin-top: 15px;"
                                                        >
                                                            <v-icon>{{icon.fork}}</v-icon>
                                                            FORK
                                                        </v-btn>
                                                        <v-btn
                                                                :color="joinRequestedText.show ? 'primary' :'success'"
                                                                :disabled="disableBtn"
                                                                @click="requestInviteUser()"
                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                text
                                                        >
                                                            <div v-if="joinRequestedText.show">
                                                                <v-icon>{{icon.join}}</v-icon>
                                                            </div>
                                                            {{ joinRequestedText.text }}
                                                        </v-btn>
                                                    </div>
                                                    <div v-else>
                                                        <v-btn
                                                                text
                                                                v-if="isMineProject || isClazzModeling"
                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                color="primary"
                                                                :disabled="disableBtn"
                                                                @click="saveComposition('save')"
                                                                v-on="on"
                                                        >
                                                            <v-icon>{{icon.save}}</v-icon>
                                                            SAVE
                                                        </v-btn>
                                                        <v-btn
                                                                text
                                                                v-else
                                                                color="primary"
                                                                :disabled="disableBtn"
                                                                @click="saveComposition('fork')"
                                                                style="margin-right: 5px; margin-top: 15px;"
                                                        >
                                                            <v-icon>{{icon.fork}}</v-icon>
                                                            FORK
                                                        </v-btn>
                                                    </div>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                            v-if="!isClazzModeling"
                                                            v-for="(item, index) in saveItems"
                                                            :key="index"
                                                            @click="functionSelect(item.title,index)"
                                                    >
                                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </slot>

                                        <slot name="shareButton">
                                            <v-menu
                                                    v-if="isMineProject && isServerModeling&& !getReadOnly "
                                                    offset-y
                                                    open-on-hover
                                                    left
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <div>
                                                        <v-btn
                                                                text
                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                color="primary"
                                                                :disabled="!initLoad"
                                                                v-on="on"
                                                                @click="openInviteUsers()"
                                                        >
                                                            <v-icon>{{icon.share}}</v-icon>
                                                            SHARE
                                                            <v-avatar v-if="requestCount" size="25" color="red"
                                                                      style="margin-left: 2px;"> {{ requestCount }}
                                                            </v-avatar>
                                                        </v-btn>
                                                    </div>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                            v-for="(item, index) in shareItems"
                                                            :key="index"
                                                            @click="functionSelect(item.title,index)"
                                                    >
                                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </slot>

                                        <!-- <slot name="codeButton">
                                            <v-menu
                                                    class="pa-2"
                                                    open-on-hover
                                                    offset-y
                                                    left
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <div>
                                                        <v-btn
                                                                text
                                                                style="margin-right: 5px; margin-top: 15px; color: white;"
                                                                color="orange"
                                                                :disabled="disableBtn"
                                                                @click="codeModalShow()"
                                                                v-on="on"
                                                        >
                                                            <v-icon> {{ icon.code}}</v-icon>
                                                            CODE
                                                        </v-btn>
                                                    </div>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                            v-for="(item, index) in codeItems"
                                                            :key="index"
                                                            @click="functionSelect(item.title,index)"
                                                    >
                                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </slot> -->


                                    </v-row>
                                </div>
                            </div>
                        </v-row>
                    </v-flex>
                </slot>
                <v-fab-transition>
                    <v-btn
                            v-if="!rtcLogin && ((isServerModeling && (information && information.permissions)) )"
                            color="blue"
                            dark
                            fab
                            small
                            absolute
                            bottom
                            right
                            style="margin:0 5px 40px 0;"
                            @click="onJoin()"
                    >
                        <v-icon>mdi-camera</v-icon>
                    </v-btn>
                </v-fab-transition>
            </v-layout>


            <v-card class="tools" style="top:100px; text-align: center;">
                <span class="bpmn-icon-hand-tool" v-bind:class="{ icons : !dragPageMovable, hands : dragPageMovable }"
                      _width="30"
                      _height="30" v-on:click="toggleGrip">
                     <v-tooltip md-direction="right">Hands</v-tooltip>
                </span>
                <v-tooltip v-for="(item, key) in elementTypes" :key="key" right>
                    <template v-slot:activator="{ on }">
                        <span
                                class="draggable"
                                align="center"
                                :_component="item.component"
                                :_width="item.width"
                                :_height="item.height">
                        <img height="30px" width="30px" :src="item.src" v-on="on"
                             v-if="!getReadOnly && !isHexagonalModeling">
                        </span>
                    </template>
                    <span>{{item.label}}</span>
                </v-tooltip>
            </v-card>

            <modal name="code-modal" :width="codeModalWidth" :height='"auto"' scrollable @closed="closeCodeModal">
                <v-dialog v-model="settingGitInfoDialog" max-width="290">
                    <v-card>
                        <v-card-title>Git Configure</v-card-title>
                        <v-card-text>
                            <v-radio-group
                                    v-model="gitInfo.type"
                                    row
                            >
                                <v-radio
                                        label="Github"
                                        value="github"
                                ></v-radio>
                                <v-radio
                                        disabled
                                        label="Gitlab"
                                        value="gitlab"
                                ></v-radio>
                            </v-radio-group>
                            <v-text-field
                                    v-model="gitInfo.name"
                                    label="Repository Name"
                            ></v-text-field>
                            <v-text-field
                                    v-model="gitInfo.token"
                                    label="Git Token"
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text @click="setGitRepository()">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-card flat>
                    <v-card-title>
                        <v-col
                                :col="2"
                        >
                            <span class="headline" v-if="changedModifying">Merge with exsiting changes</span>
                            <span class="headline" v-else>Code Preview</span>
                        </v-col>
                        <!--                        <v-col-->
                        <!--                                :col="2"-->
                        <!--                        >-->
                        <!--                            <v-row>-->
                        <!--                                <v-checkbox-->
                        <!--                                        v-model="mergedExist"-->
                        <!--                                        :label="`Merge With Existing Code`"-->
                        <!--                                ></v-checkbox>-->
                        <!--                                <v-progress-circular-->
                        <!--                                        v-if="loadMerge"-->
                        <!--                                        style="margin-left: 10px; margin-top: 18px;"-->
                        <!--                                        :size="26"-->
                        <!--                                        indeterminate-->
                        <!--                                        tiny-->
                        <!--                                        color="primary"-->
                        <!--                                ></v-progress-circular>-->
                        <!--                            </v-row>-->
                        <!--                            <p class="text-caption" style="position:absolute; color: #E53935">IDE에서 수정된 사항이 반영되지 않았을 경우-->
                        <!--                                캐시제거를 해주시기 바랍니다.</p>-->
                        <!--                        </v-col>-->
                        <v-col>
                            <v-select
                                    :items="templateList"
                                    v-model="template"
                                    label="Select Template"
                                    item-text="display"
                                    item-value="template"
                                    hide-details
                                    class="pa-0"
                            ></v-select>
                            <v-row style="height: 25px; margin-left: 5%;">
                                <v-checkbox
                                        v-model="isSecurity"
                                        label="Spring Security"
                                        hide-details
                                        style="font-size: 10px;"
                                        dense
                                        @click="changedTopping()"
                                ></v-checkbox>
                                <v-checkbox
                                        v-model="isRollout"
                                        label="Argo + Istio"
                                        style="font-size: 10px; margin-left: 10px;"
                                        dense
                                        @click="changedTopping()"
                                ></v-checkbox>
                                <v-checkbox
                                        v-model="isServiceMesh"
                                        label="Istio"
                                        style="font-size: 10px; margin-left: 10px;"
                                        dense
                                        @click="changedTopping()"
                                ></v-checkbox>
                                <v-checkbox
                                        v-model="isIngress"
                                        label="Ingress"
                                        style="font-size: 10px; margin-left: 10px;"
                                        dense
                                        @click="changedTopping()"
                                ></v-checkbox>
                            </v-row>
                        </v-col>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="width: auto; height: auto;">
                        <v-row
                                class="mb-6"
                                no-gutters
                        >
                            <v-col
                                    style="margin-right: 15px; border-right: 1px solid black; max-height: 550px; max-width: 400px;"
                                    id="scroll-target"
                                    class="overflow-auto"
                            >
                                <v-treeview
                                        v-if="changedModifying"
                                        :items.sync='changedTmp'
                                        :active.sync="openCode"
                                        activatable
                                        item-key="key"
                                        return-object
                                        :transition="treeOpen"
                                        open-on-click
                                        transition
                                        dense
                                >
                                    <template v-slot:prepend="{ item, open }">
                                        <v-icon v-if="item.changed > 0">
                                            mdi-autorenew
                                        </v-icon>
                                        <v-icon v-if="item.isNew">
                                            mdi-plus
                                        </v-icon>
                                    </template>
                                    <template v-slot:append="{ item, open }" color="red">
                                        {{item.changed == 0 ? "" : item.changed}}
                                    </template>
                                </v-treeview>
                                <v-treeview
                                        v-else
                                        :items.sync='treeList'
                                        :active.sync="openCode"
                                        activatable
                                        item-key="key"
                                        return-object
                                        :transition="treeOpen"
                                        open-on-click
                                        transition
                                        dense
                                >
                                    <template v-slot:prepend="{ item, open }">
                                        <v-icon v-if="!item.file">
                                            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                        </v-icon>
                                        <v-icon v-else>
                                            {{ icon[item.file] }}
                                        </v-icon>
                                    </template>
                                    <template v-slot:append="{ item, open }" color="red">
                                        {{item.changed == 0 ? "" : item.changed}}
                                    </template>
                                </v-treeview>
                            </v-col>
                            <v-col>
                                <!--                                <v-tabs-->
                                <!--                                        v-if="!mergedExist"-->
                                <!--                                        color="deep-purple accent-4"-->
                                <!--                                >-->
                                <!--                                    <v-tab>Template</v-tab>-->
                                <!--                                    <v-tab>IDE</v-tab>-->
                                <!--                                    <v-tab>Three-way</v-tab>-->
                                <!--                                    <v-tab-item-->
                                <!--                                            :key="0"-->
                                <!--                                    >-->
                                <!--                                        <v-container fluid>-->
                                <!--                                            <code-viewer-->
                                <!--                                                    v-if="codeViewing"-->
                                <!--                                                    v-model="openCode"></code-viewer>-->
                                <!--                                        </v-container>-->
                                <!--                                    </v-tab-item>-->
                                <!--                                    <v-tab-item-->
                                <!--                                            :key="1"-->
                                <!--                                    >-->
                                <!--                                        <v-container fluid>-->
                                <!--                                            <code-viewer-->
                                <!--                                                    v-if="codeViewing"-->
                                <!--                                                    v-model="openCodeWeb"></code-viewer>-->
                                <!--                                        </v-container>-->
                                <!--                                    </v-tab-item>-->
                                <!--                                    <v-tab-item-->
                                <!--                                            :key="2"-->
                                <!--                                    >-->
                                <!--                                        <v-container fluid>-->
                                <!--                                            <code-viewer-->
                                <!--                                                    v-if="codeViewing"-->
                                <!--                                                    v-model="openCode"-->
                                <!--                                                    :type="'diff'"-->
                                <!--                                                    :diff-value="openCodeWeb"-->
                                <!--                                                    :create-value="openCode[0] ? mergeCodeList[openCode[0].key]:null"-->
                                <!--                                            ></code-viewer>-->
                                <!--                                        </v-container>-->
                                <!--                                    </v-tab-item>-->
                                <!--                                </v-tabs>-->
                                <div v-if="changedModifying">
                                    <h2 v-if="openCodeWeb.length > 0" style="float:left; margin-left: 27px">IDE Exist
                                        Code</h2>
                                    <h2 v-if="openCodeWeb.length > 0" style="float:right; margin-right: 27px">Merged
                                        Code</h2>
                                    <code-viewer
                                            v-if="openCodeWeb.length > 0"
                                            v-model="openCodeMerge"
                                            :type="'diff'"
                                            :diff-value="openCodeWeb"
                                            :create-value="passValue"
                                            @update="updatePathTmp"
                                    ></code-viewer>
                                    <!--                                    <MonacoEditor-->
                                    <!--                                            v-model="MonacoEditor"-->
                                    <!--                                            v-if="openCodeWeb.length > 0"-->
                                    <!--                                            theme="vs-dark"-->
                                    <!--                                            class="monaco-editor"-->
                                    <!--                                            language="yaml"-->
                                    <!--                                    ></MonacoEditor>-->
                                </div>
                                <div v-else>
                                    <!--                                    <MonacoEditor-->
                                    <!--                                            v-if="codeViewing"-->
                                    <!--                                            v-model="MonacoEditor"-->
                                    <!--                                            theme="vs-dark"-->
                                    <!--                                            class="monaco-editor"-->
                                    <!--                                            language="yaml"-->
                                    <!--                                    ></MonacoEditor>-->
                                    <code-viewer
                                            v-if="codeViewing"
                                            v-model="openCode"
                                    >
                                    </code-viewer>
                                </div>
                            </v-col>
                            <v-col style="max-height: 250px; margin-top: 12px;" v-if="gitAccessInput">
                                <v-card>
                                    <v-card-title class="headline">Template from Git</v-card-title>
                                    <v-card-text>
                                        <v-col>
                                            <v-text-field
                                                    v-model="gitUrl"
                                                    label="Git Repo URL"
                                            ></v-text-field>
                                            <v-text-field
                                                    disabled-v-if="!gitAccessTokenIs"
                                                    v-model="gitAccessToken"
                                                    label="Github AccessToken"
                                            ></v-text-field>
                                        </v-col>

                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                color="red darken-1"
                                                text
                                                @click="gitAccessInput = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                color="green darken-1"
                                                text
                                                @click="saveGitToken()"
                                        >
                                            Apply
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions v-if="changedModifying">
                        <div v-if="!linkedSCM">
                            <v-icon>mdi-link-variant-off</v-icon>
                            No SCM has been configured.
                            <v-btn text type="success" @click="settingGitInfoDialog = true">Configure git</v-btn>
                        </div>
                        <div v-else>
                            <v-icon>mdi-link-variant</v-icon>
                            {{ scmUrl.replace(scmUrl.substring("8", scmUrl.indexOf("@") + 1), "") }}
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn @click="cancelModify" color="error">cancel</v-btn>
                        <v-btn @click="endModify" color="green">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </modal>
        </v-layout>

        <participant-panel
                v-if="showParticipantPanel"
                :lists="participantLists"
        ></participant-panel>

        <!--  dialog       -->
        <invite-user-dialog
                v-model="inviteLists"
                :showDialog="inviteDialog"
                :checkPublic="showPublicModel"
                @all="invitePublic"
                @apply="applyInviteUsers"
                @close="closeInviteUsers"
                @add="addInviteUser"
                @remove="removeInviteUser"
        ></invite-user-dialog>

        <model-storage-dialog
                :condition="storageCondition"
                :showDialog="showStorageDialog"
                @save="saveModel"
                @fork="forkModel"
                @backup="backupModel"
                @close="storageDialogCancel"
        >
        </model-storage-dialog>

        <!-- <v-overlay v-if="loadMerge" :absolute="true">
            <v-progress-circular indeterminate></v-progress-circular>
            소스코드 생성중...
        </v-overlay> -->


        <dialog-purchase-item
                v-model="purchaseItemDialog"
                :purchase-item-info="purchaseItemDialogInfo"
                @result="purchaseItemDialogSubmit"
                @close="purchaseItemDialogClose"
        >
        </dialog-purchase-item>

        <!--        <v-dialog v-model="ideCheckDialog" max-width="340">-->
        <!--            <v-card>-->
        <!--                <v-card-title class="headline">Project IDE</v-card-title>-->
        <!--                <v-card-text>-->
        <!--                    <div style="color: #8b0000; font-size: medium">파일을 업데이트 하시겠습니까?</div>-->
        <!--                    &lt;!&ndash;                    <div style="color: #000000"></div>&ndash;&gt;-->
        <!--                    <v-checkbox label="Github 연동 (Github 로그인 필요) " v-model="githubCheck"></v-checkbox>-->
        <!--                    <v-checkbox label="초기화 (체크 시, 기존 파일이 모두 삭제됩니다.)" v-model="ideUpdateCheck"></v-checkbox>-->
        <!--                </v-card-text>-->
        <!--                <v-card-actions>-->
        <!--                    <v-spacer></v-spacer>-->
        <!--                    <v-btn color="green darken-1" text @click="openProjectIDE()">OK</v-btn>-->
        <!--                    <v-btn color="red darken-1" text @click="ideCheckDialog = false">Cancel</v-btn>-->
        <!--                </v-card-actions>-->
        <!--            </v-card>-->
        <!--        </v-dialog>-->

        <v-dialog
                v-model="resourceQuotaDialog"
                @click:outside="closeResourceQuota()"
                max-width="550"
        >
            <div style="text-align: -webkit-center;">
                <ide-resource-dialog @submit="closeResourceQuota"></ide-resource-dialog>
            </div>
        </v-dialog>

        <v-dialog v-model="generateZipDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Generate Zip Archive</v-card-title>
                <v-card-text>
                    <v-select
                            :items="templateList"
                            v-model="template"
                            label="Select Template"
                            hide-details
                            class="pa-0"
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!isDownloading">
                        <v-btn text @click="generateZipDialog = false">Cancel</v-btn>
                        <v-btn color="primary" text @click="checkedPaidItem()">Download</v-btn>
                    </div>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="tokenDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Token Dialog</v-card-title>
                <v-card-text>
                    <v-text-field v-model="clusterAddress" label="Cluster Address"
                                  required></v-text-field>
                    <v-text-field v-model="kubernetesToken" label="Kubernetes Token"
                                  required></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="tokenSave()">Download</v-btn>
                    <v-btn color="red darken-1" text @click="tokenDialog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="forkAlertDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Fork
                    <v-icon>{{icon.fork}}</v-icon>
                </v-card-title>
                <v-card-text> 권한이 없어서 수정 할 수 없습니다. Fork를 하여 사용해 주세요.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="saveComposition('fork')">Fork</v-btn>
                    <v-btn color="red darken-1" text @click.native="forkAlertDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--   model IMAGE     -->
        <modeler-image-generator ref="modeler-image-generator"></modeler-image-generator>
        <!-- autoPay -->
        <auto-payment-composition></auto-payment-composition>


        <hsc-window-style-metal>
            <hsc-window title="User Camera"
                        :closeButton="true"
                        :isOpen.sync="webRtcDialog"
                        :resizable="true"
                        :isScrollable="true"
                        :minWidth="400"
                        :minHeight="110"
                        :maxWidth="800"
                        :maxHeight="110"
                        positionHint="5 / -10"
                        style="
                        color: rgb(0, 0, 0);
                        box-shadow: rgba(0, 0, 0, 0.5) 0px 4pt 8pt;
                        background: linear-gradient(rgb(255, 255, 255), rgb(255, 255, 255));
                        z-index: 0;
                        overflow: visible;
                        width: 404px;
                        height: 154.2px;"
            >
                <v-layout>
                    <v-col>
                        <v-row style="margin-left: 2px; margin-bottom: 2px">
                            <vue-webrtc ref="webrtc"
                                        width="100%"
                                        height="160px"
                                        cameraHeight="50px"
                                        enableAudio
                                        class="video-list"
                                        :roomId="rtcRoomId"
                                        @error="onError"/>

                        </v-row>
                    </v-col>
                </v-layout>
            </hsc-window>
        </hsc-window-style-metal>
    </div>
</template>

<script>
    import ModelCanvas from "../modeling/ModelCanvas";
    import TextReader from "@/components/yaml.vue";
    import CodeViewer from "../CodeViewer";
    import MonacoEditor from 'vue-monaco';
    // import CodeViewer from "./EventStormingCodeViewer";

    import {
        mdiAbTesting
    } from '@mdi/js';
    import * as io from 'socket.io-client';
    import DiffMatchPatch from "diff-match-patch";

    var JSZip = require('jszip')
    var yamlpaser = require('js-yaml');
    var changeCase = require('change-case');
    var pluralize = require('pluralize');
    var path = require('path')
    var Minio = require('minio');
    var ConfigIniParser = require("config-ini-parser").ConfigIniParser;
    var delimiter = "\r\n"; //or "\n" for *nux
    import {diffString, diff} from "json-diff";

    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    export default {
        name: 'sticky-model-canvas',
        mixins: [ModelCanvas],
        components: {
            TextReader,
            saveAs,
            CodeViewer,
            mdiAbTesting,
            diffString, diff,
            io,
            MonacoEditor,
        },
        props: {
            labId: String,
        },
        data() {
            return {
                //Hexagonal
                isHexagonal: false,
                hexagonalValue: null,

                settingGitInfoDialog: false,
                linkedSCM: false,
                scmUrl: null,
                monacoEditor: '',
                fab: false,
                sshUrl: "",
                gitInfo: {
                    name: "",
                    type: "github",
                    token: ""
                },
                // 윈도우
                windowWidth: window.innerWidth,
                ideUpdateCheck: false,
                githubCheck: false,
                ideCheckDialog: false,
                codeModalWidth: '80%',
                mergedExist: true,
                gitAccessToken: '',
                gitAccessTokenIs: false,
                gitAccessInput: false,

                deleteSnackbar: false,
                deleteBounded: "",
                isNetworkOffline: false,
                //db permission
                isMultiShareType: 'ReadOnly',
                isMultiShareTypeList: ['ReadOnly', 'Write'],
                codeLoading: false,
                codeViewing: false,
                changedCount: 0,
                test: [],
                versionItems: [
                    {title: 'Versions'},
                ],
                shareItems: [
                    {title: 'Share'},
                ],
                saveItems: [
                    {title: 'Save to Server'},
                    {title: 'Download model File'},
                    {title: 'Duplicate'},
                ],
                openItems: [
                    {title: 'Open from Files'},
                    {title: 'Open from Local'},
                ],
                codeItems: [
                    {title: 'Code Preview'},
                    {title: 'Download Archive'},
                    {title: 'Project IDE'}
                ],


                projectNameHint: null,
                projectNameColor: null,
                rules: {
                    required: value => !!value || 'ProjectName required.',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    emailMatch: () => ('The email and password you entered don\'t match'),
                },
                // duplicateproject: false,
                generateZipDialog: false,
                isDownloading: false,
                imageBase: 'https://raw.githubusercontent.com/kimsanghoon1/k8s-UI/master/public/static/image/symbol/',
                // //스낵바 옵션
                // snackbar:{
                //     show:false,
                //     color:'error',
                //     mode: 'multi-line',
                //     timeout: 6000,
                //     text: '',
                // },
                // snackbar: false,
                // color: 'error',
                // mode: 'multi-line',
                // timeout: 6000,
                // text: '수정중입니다.',
                //Zip

                resourceQuotaDialog: false,
                setResourceQuota: false,
                //ide
                resourceQuota: {
                    memory: "4Gi",
                    cpu: "2"
                },
                resourceType: 'ide-4m2c',
                //tool
                toolResourceQuota: {
                    memory: "4Gi",
                    cpu: "2",
                },
                toolResourceType: 'k8s-4m2c',

                pathTmp: [],
                changedTmp: [],
                gitCodeUrl: {},
                mergeStatus: null,
                passValue: [],
                //data structure
                model: [],
                fullPathList: [],
                treeList: [],
                mergeTreeList: [],
                getCodeList: [],
                mergeCodeList: [],
                openCode: [],
                openCodeWeb: [],
                openCodeMerge: [],
                template: '',
                defaultTemplate: 'spring-boot',
                // topping
                preferredToppingPlatforms: [],
                isSecurity: false,
                isServiceMesh: false,
                isRollout: false,
                isIngress:false,

                treeOpen: true,
                gitUrl: '',
                gitPath: [],
                gitCode: [],
                checkName: true,
                changedModifying: false,
                cancelModifying: false,
                // Children
                drawer: false,
                chatUid: '',
                messageRef: {},
                //version
                versionList: [],
                version: '',
                revisionInfo: {},
                kubernetesToken: '',
                clusterAddress: '',
                tokenDialog: false,

                //replay

                //view
                viewSelect: {},
                viewOpenId: '',
                defaultValue: '',
                //edit
                //fork
                forkAlertDialog: false,
                elementTypes: [
                    {
                        'icon': 'bpmn-icon-start-event-none',
                        'component': 'stickyNoteBoard',
                        'label': 'Sticky Note Board',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/event.png`,
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',
                        'component': 'stickyNoteBoard',
                        'label': 'Sticky Note Board',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/command.png`,
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',
                        'component': 'stickyNoteBoard',
                        'label': 'Sticky Note Board',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/policy.png`,
                        'color': '#BB94BF'
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',
                        'component': 'stickyNoteBoard',
                        'label': 'Sticky Note Board',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/aggregate.png`,
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',
                        'component': 'stickyNoteBoard',
                        'label': 'Sticky Note Board',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/external.png`,
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',
                        'component': 'stickyNoteBoard',
                        'label': 'Sticky Note Board',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/view.png`,
                    },
                    {
                        'icon': 'bpmn-icon-start-issue-none',
                        'component': 'stickyNoteBoard',
                        'label': 'Sticky Note Board',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/issue.png`,
                    },
                    {
                        'component': 'sticky-line-element',
                        'label': 'Line',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/symbol/edge.png`,
                    },
                    {
                        'component': 'sticky-text-element',
                        'label': 'Text',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/symbol/text_element.png`,
                    },
                ],

            }
        },
        computed: {
            isHexagonalModeling() {
                return this.isHexagonal
            },
            getUserCoin() {
                if (this.userInfo.savedCoin) {
                    return this.userInfo.savedCoin
                }
                return 0
            },
            getUserToolTime() {
                if (this.userInfo.savedToolTime) {
                    return this.userInfo.savedToolTime.toFixed(1)
                }
                return 0
            },
            getReadOnly() {
                return this.readOnly
            },
            loadMerge() {
                if (!this.mergeStatus && this.mergeStatus != null) {
                    return true
                }
                return false
            },
            disableBtn() {
                if (this.disableModel || !this.initLoad) {
                    return true
                }
                return false
            },
            attachedLists() {
                var me = this
                var bounedTmp = {}
                var aggregateTmp = {}
                var eventTmp = {}

                Object.values(me.value.elements).forEach(function (element) {
                    if (element != null) {
                        if (element._type == 'org.uengine.modeling.model.BoundedContext') {
                            me.$set(bounedTmp, element.elementView.id, element)
                        } else if (element._type == 'org.uengine.modeling.model.Aggregate') {
                            me.$set(aggregateTmp, element.elementView.id, element)
                        } else if (element._type == 'org.uengine.modeling.model.Event') {
                            me.$set(eventTmp, element.elementView.id, element)
                        }
                    }

                })

                var obj = {
                    boundedContextLists: bounedTmp,
                    aggregateLists: aggregateTmp,
                    eventLists: eventTmp
                }
                return obj
            }
            ,
            templateList: function () {
                var me = this
                var list = [{display: 'Custom Template', template: ''}]
                Object.keys(me.$manifestsPerTemplate).forEach(function (template) {
                    var obj = {
                        display: template,
                        template: template
                    }
                    list.push(obj)
                })
                return list
            },
            // openCodeWebComputed: async function () {
            //
            // }
        },
        created: function () {
            var me = this
            me.canvasType = 'sticky'
            // me.isQueueModel = true
            me.track()

        },
        mounted: function () {

            var me = this
            // DeployData CallBack
            me.$EventBus.$on('deploy', async function (boundedId) {
                await me.getListSetting();
                me.generateZipToFireBase(boundedId);
            });
            me.$EventBus.$on('downloadCode', async function () {
                await me.generateZip()
            });
            if (localStorage.getItem("gitAccessToken"))
                me.gitInfo.token = localStorage.getItem("gitAccessToken")

        }
        ,
        watch: {
            copyValue: {
                deep: true,
                handler: function (newVal, oldVal) {
                    var me = this
                    var delta = jsondiffpatch.diff(oldVal, newVal);
                    if (me.initLoad && delta) {
                        me.modifiedElement(delta)
                    }
                }
            },
            value: {
                deep: true,
                handler:
                    _.debounce(function (newVal, oldVal) {
                        var me = this
                        if (newVal) {
                            // me.$EventBus.$emit('lab-definition', newVal) //this must be deprecated

                            // following is right way
                            me.$emit("input", newVal);
                            me.$emit("change", newVal, me.projectName);
                            if ((me.paramKeys.indexOf('classId') != -1) || (me.initLoad && me.value && me.value.elements)) {
                                var filterName = JSON.parse(JSON.stringify(me.projectName))

                                filterName = me.filterProjectName(filterName)
                                // var pattern1 = /[0-9ㄱ-ㅎ|ㅏ-ㅣ|가-힣~!@#$%^&*()_+|<>?:{}]/gi; // 영어 소문자
                                //
                                // if (filterName) {
                                //     if (pattern1.test(filterName)) {
                                //         filterName = filterName.replace(pattern1, '');
                                //     }
                                //     filterName = filterName.toLowerCase()
                                // }
                                // me.$emit("codeChange", me.convertModelForCodeGen(me.value, filterName));
                                // me.$emit("codeList", me.getCodeList);
                            }
                        }
                    }, 1000)
            },
            async openCode() {
                var resultTmp;
                var me = this
                // if (!me.changedModifying) {
                console.log('openCode------------')
                me.openCodeWeb = []
                var me = this
                var result = []
                var obj = me.openCode;
                me.getCodeList.forEach(async function (item) {
                    if (item && obj[0] && obj[0].key == item.key) {
                        resultTmp = JSON.parse(JSON.stringify(me.openCode));
                        var code = await me.getCode(resultTmp[0].path);
                        item.code = code
                        result.push(item)
                        me.passValue = result
                    }
                });
                if (this.openCode.length > 0) {
                    me.codeLoading = true;

                    resultTmp = JSON.parse(JSON.stringify(this.openCode));
                    // Minio 사용 버전

                    // var code = await this.getString(`cluster://${me.myId.split('@')[1].split('.')[0].toLowerCase()}/classes/running/users/labs/${me.myId}/${me.$route.params.projectId}/` + resultTmp[0].path, 'eventstorming');var code =
                    var code = await me.getCode(resultTmp[0].path);
                    me.codeLoading = false;
                    if (code) {
                        resultTmp[0].code = code;
                        me.openCodeWeb = resultTmp
                    } else {
                        me.openCodeWeb = resultTmp;
                    }

                }
                // }
            },
            openCodeWeb() {
                // if (!this.changedModifying) {
                var localCode = this.openCode[0] && this.openCode[0].code ? this.openCode[0].code : null
                // this.MonacoEditor = localCode
                if (this.openCodeWeb[0]) {
                    var ideCode = this.openCodeWeb[0].code
                    var result = this.diff_lineMode(localCode, ideCode)
                    var tmp = JSON.parse(JSON.stringify(this.openCodeWeb))
                    var tmpCode = ""
                    result.forEach(function (data) {
                        /*
                            0: 유지 / 1: 추가 / -1: 제거
                        * */
                        tmpCode = tmpCode.concat(data[1])
                    })
                    tmp[0].code = tmpCode
                    this.openCodeMerge = tmp
                } else {
                    this.openCodeMerge = localCode
                }
            },

            changedModifying: async function (newVal) {
                var me = this

                if (newVal) {
                    var parser = new ConfigIniParser("\n")
                    var initContent = await me.getGitConfig()
                    // parser.parse(iniContent);
                    var parseConfig = parser.parse(initContent);
                    console.log(parseConfig)
                    parseConfig._ini.sections.forEach(function (section) {
                        if (section.name.includes('origin')) {
                            section.options.forEach(function (option) {
                                if (option.name == 'url') {
                                    me.linkedSCM = true;
                                    me.scmUrl = option.value
                                }
                            })

                        }
                    })
                    // console.log(parser.stringify('\n')); //get all the ini file content as a string
                }
            },
            "projectName":
                _.debounce(function (newVal, oldVal) {
                    var me = this
                    if (me.initLoad) me.changed = true
                    // var pattern1 = /[0-9ㄱ-ㅎ|ㅏ-ㅣ|가-힣~!@#$%^&*()_+|<>?:{}]/gi; // 영어 소문자

                    if (newVal) {
                        me.gitInfo.name = newVal

                        me.projectNameHint = null
                        me.projectNameColor = null
                    } else {
                        me.projectNameHint = 'Project name is required.'
                        me.projectNameColor = 'red'
                    }
                }, 0),
            treeList: _.debounce(function (newVal) {
                var me = this
                me.mergeTreeList = JSON.parse(JSON.stringify(newVal));

                if (newVal.length > 0) {
                    function children(value, indexArray, depth) {
                        if (value.children) {
                            value.children.forEach(async function (data, index) {
                                if (!data.children) {
                                    try {
                                        var code = await me.getCode(data.path)
                                        if (code != undefined || code != null) {
                                            var result = me.diff_lineMode(data.code, code)
                                            if (result != undefined && result.length > 1) {
                                                result.forEach(function (data) {
                                                    if (data[0] == -1 || data[0] == 1) {
                                                        value.children[index].changed++
                                                    }
                                                })
                                            }
                                        } else {
                                            // console.log("isNew")
                                            value.children[index].isNew = true
                                        }
                                    } catch (e) {
                                        console.log(e)
                                    }

                                } else {
                                    children(data, indexArray, depth)
                                }
                            })
                        } else if (!value.name) {
                            value.forEach(function (data) {
                                children(data, indexArray, depth)
                            })
                        }

                    }

                    children(newVal)
                }

            }, 200),
            mergeTreeList: _.debounce(function (newVal) {
                var me = this
                if (newVal && newVal.length > 0) {
                    // 여기에 End 조건 절
                    var lastObject = false

                    function children(value, parentIndex) {
                        if (value.children) {
                            value.children.forEach(async function (data, index) {
                                if (!data.children) {
                                    try {
                                        var code = await me.getCode(data.path)

                                        if (code != null) {
                                            var result = me.diff_lineMode(data.code, code)
                                            if (result.length > 1) {

                                                value.children[index].changed = 0;
                                                result.forEach(function (data) {
                                                    if (data[0] == -1 || data[0] == 1) {
                                                        console.log(data[0])
                                                        value.children[index].changed++
                                                    }
                                                })
                                                value.children[index].code = "";
                                                console.log("result")
                                                console.log(result)
                                                var passedIndex;
                                                result.forEach(function (data, idx) {
                                                    if (data[0] == 0) {
                                                        value.children[index].code = value.children[index].code.concat(data[1])
                                                    } else if (data[0] == -1 && result[idx + 1] != null) {
                                                        if (result[idx + 1][0] == 1) {
                                                            if (data[1].replace(/\n/gi, "") == result[idx + 1][1].replace(/\n/gi, "")) {
                                                                return;
                                                            } else {
                                                                if (result[idx][1] != "}")
                                                                    value.children[index].code = value.children[index].code.concat(result[idx][1])
                                                                value.children[index].code = value.children[index].code.concat(result[idx + 1][1])
                                                                passedIndex = idx + 1
                                                            }
                                                        } else if (result[idx + 1][0] == 0) {
                                                            value.children[index].code = value.children[index].code.concat(data[1])
                                                        }
                                                    } else if (idx != passedIndex) {
                                                        value.children[index].code = value.children[index].code.concat(data[1])
                                                    }
                                                })

                                                if (value.children[index].code.replace(/(\n|\s)/gi, "") == code.replace(/(\n|\s)/gi, "")) {
                                                    value.children[index].changed = null;
                                                }
                                            }
                                        } else if (code == null) {
                                            value.children[index].isNew = true
                                        }
                                    } catch (e) {
                                        console.log(e)
                                    }
                                } else {
                                    children(data, index - (value.children.length - 1))
                                }


                                if (index == value.children.length - 1 && !data.children && parentIndex == 0) {
                                    console.log("end!!")
                                    me.mergeStatus = true
                                }
                            })
                        } else if (!value.name) {
                            value.forEach(function (data, index) {
                                children(data, value.length - 1 - index)
                            })
                        }
                    }

                    children(newVal)
                }
            }, 200),
            fullPathList:
                function (newVal) {
                    var me = this
                    me.treeList = newVal.reduce((children, value) => {
                        value.fullPath.split('/').reduce((folder, o, i) => {
                            if (i === 0) {
                                var p = folder;
                            } else {
                                var p = folder.children = folder.children || [];
                            }

                            let f = p.find(x => x.name === o.trim());

                            if (!f) {

                                f = {
                                    name: o.trim(),
                                    key: me.findFile(value.key, o.trim()).key,
                                    file: me.findFile(value.key, o.trim()).file,
                                    code: me.findFile(value.key, o.trim()).code,
                                    path: value.fullPath,
                                    changed: 0
                                }

                                p.push(f);
                            }
                            return f;
                        }, children);
                        return children;
                    }, []);
                },

            async preferredToppingPlatforms() {
                var me = this
                me.getListSetting()

                me.$nextTick(function () {
                    me.treeOpen = true
                })
            },
            async template() {
                var me = this
                if (me.template == 'GIT') {
                    /* Prompt -> Dialog  */
                    // console.log(me.gitUrl)
                    if (me.gitUrl.length < 3) {
                        if (!window.localStorage.getItem("gitAccessToken")) {
                            me.gitAccessTokenIs = false
                        } else {
                            me.gitAccessTokenIs = true
                        }
                        me.gitAccessInput = true
                        me.codeModalWidth = '90%';
                        return;
                    } else {
                        me.gitAccessInput = true
                    }


                    await me.gitTemplate().then(function () {
                        me.getListSetting()

                        me.$nextTick(function () {
                            me.treeOpen = true
                        })
                    })
                } else {
                    me.getListSetting()

                    me.$nextTick(function () {
                        me.treeOpen = true
                    })
                }
            }
        }
        ,
        methods: {
            changedTopping() {
                var list = []
                if (this.isSecurity) {
                    list.push('spring-security')
                }
                if (this.isRollout) {
                    list.push('argo')
                }
                if (this.isServiceMesh) {
                    list.push('istio')
                }
                if(this.isIngress){
                    list.push('ingress')
                }
                this.preferredToppingPlatforms = list
            },
            settingHexagonal(value) {
                var me = this
                var values = null
                if (value) {
                    values = JSON.parse(JSON.stringify(value))
                } else {
                    values = JSON.parse(JSON.stringify(me.value))
                }

                //// functions ////
                function descYPositionSort(arr) {
                    arr.sort(function (beforeElement, afterElement) {
                        return afterElement.elementView.y - beforeElement.elementView.y;
                    });
                    return arr
                }

                function ascYPositionSort(arr) {
                    arr.sort(function (beforeElement, afterElement) {
                        return beforeElement.elementView.y - afterElement.elementView.y;
                    });
                    return arr
                }

                //////////////


                var modelForElements = {
                    BoundedContext: [],
                    Aggregate: [],
                    Policy: [],
                    Event: [],
                    Command: [],
                    Relation: [],
                };


                if (values) {

                    if (values.elements) {
                        Object.keys(values.elements).forEach(function (id) {
                            var element = values.elements[id]
                            if (element) {
                                var typeSplit = element._type.split(".");
                                var type = typeSplit[typeSplit.length - 1]

                                if (modelForElements[type])
                                    modelForElements[type].push(element)

                                // setting name style
                                if (!element._type.endsWith("BoundedContext")) {
                                    element.elementView.width = 100
                                    if (element.name.length > 9)
                                        element.elementView.width = 100 * (element.name.length / 9)
                                    element.elementView.height = 35
                                }
                            }
                        })
                    }

                    if (values.relations) {
                        Object.keys(values.relations).forEach(function (id) {
                            var relation = values.relations[id]
                            if (relation) {
                                var typeSplit = relation._type.split(".");
                                var type = typeSplit[typeSplit.length - 1]

                                if (modelForElements[type])
                                    modelForElements[type].push(relation)

                            }
                        })
                    }


                    // BoundedContext inner setting
                    modelForElements.BoundedContext.forEach(bc => {
                            Object.values(values.elements).forEach((element, index) => {
                                if (element && element.elementView && !element._type.endsWith("BoundedContext")) {

                                    var outer = {
                                        x: bc.elementView.x - bc.elementView.width / 2,
                                        y: bc.elementView.y - bc.elementView.height / 2,
                                        width: bc.elementView.width,
                                        height: bc.elementView.height
                                    }

                                    var inner = {
                                        x: element.elementView.x - element.elementView.width / 2,
                                        y: element.elementView.y - element.elementView.height / 2,
                                        width: element.elementView.width,
                                        height: element.elementView.height
                                    }


                                    if (this._isAttached(outer, inner)) {
                                        var bcElement = values.elements[bc.elementView.id]
                                        var typeSplit = element._type.split(".");
                                        var type = typeSplit[typeSplit.length - 1]
                                        if (bcElement) {
                                            if (!bcElement.innerElements) bcElement.innerElements = {}
                                            if (type == 'Command' || type == 'Policy') {
                                                //input
                                                if (!bcElement.innerElements.inputAdapters)
                                                    bcElement.innerElements.inputAdapters = []
                                                bcElement.innerElements.inputAdapters.push(element)
                                            } else if (type == 'Event') {
                                                //output
                                                if (!bcElement.innerElements.outputAdapters)
                                                    bcElement.innerElements.outputAdapters = []
                                                bcElement.innerElements.outputAdapters.push(element)
                                            } else {
                                                // etc
                                                if (!bcElement.innerElements[type]) {
                                                    bcElement.innerElements[type] = []
                                                }
                                                bcElement.innerElements[type].push(element)
                                            }
                                        }
                                    }
                                }
                            })
                        }
                    )


                    //setting BoundedContext
                    modelForElements.BoundedContext.forEach(bc => {
                        var standard = 30

                        if (bc) {
                            if (bc.elementView.width < bc.elementView.height) {
                                bc.elementView.width = bc.elementView.height
                            } else {
                                bc.elementView.height = bc.elementView.width
                            }
                        }


                        if (bc && bc.innerElements) {
                            //BoundedContext
                            var bcX = bc.elementView.x
                            var bcY = bc.elementView.y
                            var bcW = bc.elementView.width
                            var bcH = bc.elementView.height


                            //InputAdapters
                            if (bc.innerElements && bc.innerElements.inputAdapters) {
                                bc.innerElements.inputAdapters = descYPositionSort(bc.innerElements.inputAdapters)
                                var inputLen = bc.innerElements.inputAdapters.length
                                var xDistance = (bcW / 2) / inputLen
                                var yDistance = (bcH / 2) / inputLen

                                bc.innerElements.inputAdapters.forEach((inputAdapter, index) => {
                                    var itemH = inputAdapter.elementView.height
                                    var itemW = inputAdapter.elementView.width

                                    if ((standard < (bcH / 2 / inputLen)) || (standard * index) < (bcH / 2.2)) {
                                        // top
                                        if (yDistance < standard) {
                                            yDistance = standard
                                        } else if (yDistance > 65) {
                                            yDistance = 60
                                            xDistance = 60
                                        }

                                        inputAdapter.elementView.y = (bcY - (itemH / 2)) - ((yDistance * index))
                                        inputAdapter.elementView.x = (bcX - (bcW / 2)) - (itemW / 3) - (xDistance * 0.4 * index) + (xDistance * index)
                                    } else {
                                        // bottom
                                        inputAdapter.elementView.y = (bcY - (itemH / 2)) + ((yDistance * (inputLen - index))) + 10
                                        inputAdapter.elementView.x = (bcX - (bcW / 2)) - (itemW / 3) + (xDistance * (inputLen - index)) - (xDistance * 0.4 * (inputLen - index))
                                    }
                                })
                            }

                            //OutputAdapters
                            if (bc.innerElements && bc.innerElements.outputAdapters) {
                                var outputLen = bc.innerElements.outputAdapters.length
                                var xDistance = (bcW / 2) / bc.innerElements.outputAdapters.length
                                var yDistance = (bcH / 2) / bc.innerElements.outputAdapters.length

                                bc.innerElements.outputAdapters = ascYPositionSort(bc.innerElements.outputAdapters)
                                bc.innerElements.outputAdapters.forEach((outputAdapter, index) => {
                                    var itemH = outputAdapter.elementView.height
                                    var itemW = outputAdapter.elementView.width

                                    if ((standard < (bcH / 2 / outputLen)) || (standard * index) < (bcH / 2.2)) {
                                        // bottom
                                        if (yDistance < standard) {
                                            yDistance = standard
                                        } else if (yDistance > 65) {
                                            yDistance = 60
                                            xDistance = 60
                                        }
                                        outputAdapter.elementView.y = (bcY + (itemH / 2)) + ((yDistance * index))
                                        outputAdapter.elementView.x = (bcX + (bcW / 2)) + (itemW / 3) + (xDistance * 0.4 * index) - (xDistance * index)
                                    } else {
                                        // top
                                        outputAdapter.elementView.y = (bcY + (itemH / 2)) - ((yDistance * (outputLen - index))) - 5
                                        outputAdapter.elementView.x = (bcX + (bcW / 2)) + (itemW / 3) - (xDistance * (outputLen - index)) + (xDistance * 0.4 * (outputLen - index))
                                    }


                                    // outputAdapter.elementView.y = (bcY + (itemH / 2)) + (itemH * (1.3 * index))
                                    // outputAdapter.elementView.x = (bcX + bcW / 2) + (itemW / 2.5) - (xDistance * index) + (xDistance * 0.6 * index)
                                })
                            }
                        }
                    })
                    //end BoundedContext

                    // setting Relation
                    modelForElements.Relation.forEach(relation => {
                        if (relation) {
                            relation = me.redrawConnectShape(relation)
                        }
                    })
                    // end Relation
                }
                return values
            },
            redrawConnectShape(beforeRelation) {
                var me = this;

                if (beforeRelation.relationView.value) {
                    var vertices = JSON.parse(beforeRelation.relationView.value)
                    var start = vertices[0]
                    var end = vertices[vertices.length - 1]
                    var newVertices = JSON.stringify([start, end])

                    // modify relation
                    beforeRelation.relationView.value = newVertices
                    beforeRelation.relationView.style = null
                }
                return beforeRelation
            },
            generateHexagonal(value) {
                var me = this
                me.hexagonalValue = me.settingHexagonal(value)
                if (me.hexagonalValue)
                    me.isHexagonal = true
            },
            generateModel() {
                var me = this
                me.isHexagonal = false
            },
            getGitConfig() {
                var me = this
                return new Promise(function (resolve, reject) {
                    var gitParams = new URLSearchParams();
                    var projectId = me.$route.params.projectId;
                    var userName = localStorage.getItem("email").split('@')[0].toLowerCase();
                    var userGroup = localStorage.getItem("email").split('@')[1].split('.')[0].toLowerCase();
                    var projectName = me.projectName.toLowerCase();
                    var projectId = me.$route.params.projectId;
                    gitParams.append('filePath', `labs-eventstorming/${userGroup}/classes/running/users/labs/${localStorage.getItem("author")}`);
                    gitParams.append('lab', `${projectId}`);
                    gitParams.append('hashName', `${hashName}`);
                    me.$http.get(`${me.getProtocol()}//file.kuberez.io/api/getGitConfig`, {
                        params: {
                            "filePath": `labs-eventstorming/${userGroup}/classes/running/users/labs/${localStorage.getItem("author")}`,
                            'lab': `${projectId}`
                        }
                    }).then(function (result) {
                        console.log(result)
                        resolve(result.data)
                    }).catch(error => alert(error))
                })

            }
            ,
            closeCodeModal() {
                this.openCode = []
            }
            ,
            closeResourceQuota(ide, tool) {
                if (ide) {
                    //ide
                    this.resourceQuota = ide.resourceQuota
                    this.resourceType = ide.resourceType
                    //tool
                    this.toolResourceQuota = tool.resourceQuota
                    this.toolResourceType = tool.resourceType
                    //status
                    this.setResourceQuota = true
                }
                this.resourceQuotaDialog = false
            }
            ,
            updatePathTmp(update) {
                var me = this
                me.pathTmp.forEach(function (item) {
                    if (item.key == update.key) {
                        console.log(update)
                        item.code = update.code
                    }
                })
            }
            ,
            cancelModify() {
                var me = this
                this.cancelModifying = false
                me.$EventBus.$emit("openProgressing");
                this.$modal.hide('code-modal')
                // this.openCode = []
            }
            ,
            endModify() {
                var me = this
                this.changedModifying = false
                me.$EventBus.$emit("openProgressing");
                this.$modal.hide('code-modal')
                // this.openCode = []
            }
            ,
            async checkedPaidItem() {
                var me = this
                me.isDownloading = true
                if (me.isLogin) {
                    var convertEmail = me.userInfo.email.replace(/\./gi, '_')
                    var getItemId = null
                    var isPaid = false

                    if (me.isClazzModeling) {
                        var classInfo = await this.getClassInfo()
                        var labInfo = await this.getLabInfo()
                        getItemId = `${me.canvasType}_${classInfo.courseId}@${classInfo.classId}@${labInfo.labId}`
                        me.purchaseItemDialogInfo.className = classInfo.className
                        me.purchaseItemDialogInfo.labName = labInfo.labName
                        if (classInfo && !classInfo.openClass && classInfo.connectionKey) {
                            isPaid = true
                        }
                    } else {
                        getItemId = `${me.canvasType}_${this.$route.params.projectId}`
                    }

                    if (!isPaid) {
                        var checkSubscription = await me.getObject(`db://enrolledUsers/${convertEmail}/purchaseItemSnapshots/subscription`)
                        if (checkSubscription) {
                            var checkExpired = checkSubscription.expiredDate ? checkSubscription.expiredDate : 0
                            if (typeof checkExpired == 'string') checkExpired = Number(checkExpired)
                            if (checkExpired == 0 || Date.now() < checkExpired) {
                                if (checkSubscription.downloadCode != 0) {
                                    isPaid = true
                                }
                            }
                        } else {
                            var checkItem = await me.getObject(`db://enrolledUsers/${convertEmail}/purchaseItemSnapshots/${getItemId}`)
                            if (checkItem) {
                                var checkExpired = checkItem.expiredDate ? checkItem.expiredDate : 0
                                if (typeof checkExpired == 'string') checkExpired = Number(checkExpired)
                                if (checkExpired == 0 || Date.now() < checkExpired) {
                                    isPaid = true
                                }
                            }
                        }
                    }

                    if (isPaid) {
                        await me.generateZip()
                    } else {
                        me.purchaseItemDialogOpen(getItemId)
                    }

                } else {
                    me.$EventBus.$emit('showLoginDialog', true)
                }
            },
            bindEvents: function (opengraph) {
                var me = this;
                var el = me.$el;
                var canvasEl = $(opengraph.container);
                if (!canvasEl || !canvasEl.length) {
                    return;
                }

                this.canvas = opengraph.canvas;
                //아이콘 드래그 드랍 이벤트 등록
                $(el).find('.draggable').draggable({
                    start: function () {
                        canvasEl.data('DRAG_SHAPE', {
                            'component': $(this).attr('_component'),
                            'width': $(this).attr('_width'),
                            'height': $(this).attr('_height'),
                            'description': $(this).attr('_description'),
                            'src': $(this).children('img').attr('src'),
                        });
                    },
                    helper: 'clone',
                    appendTo: canvasEl
                });

                canvasEl.droppable({
                    drop: function (event, ui) {
                        var componentInfo = canvasEl.data('DRAG_SHAPE'),
                            shape, element;
                        if (componentInfo) {
                            var dropX = event.pageX - canvasEl.offset().left + canvasEl[0].scrollLeft;
                            var dropY = event.pageY - canvasEl.offset().top + canvasEl[0].scrollTop;
                            var scale = opengraph.canvas._CONFIG.SLIDER[0].innerText / 100

                            dropX = dropX / scale;
                            dropY = dropY / scale;

                            componentInfo = {
                                component: componentInfo.component,
                                x: dropX,
                                y: dropY,
                                width: parseInt(componentInfo.width, 10),
                                height: parseInt(componentInfo.height, 10),
                                description: componentInfo.description ? componentInfo.description : '',
                                src: componentInfo.src ? componentInfo.src : '',
                            }


                            me.addElement(componentInfo);
                        }
                        canvasEl.removeData('DRAG_SHAPE');
                    }
                });
            },
            addElement: function (componentInfo, bounded) {
                this.enableHistoryAdd = true;
                var me = this;
                var additionalData = {};
                var vueComponent = me.getComponentByName(componentInfo.component);
                var element;

                if(!componentInfo.isRelation) {
                    if(componentInfo.src.includes('event.png')) {
                        componentInfo.color = '#F1A746'
                    } else if(componentInfo.src.includes('command.png')) {
                        componentInfo.color = '#5099F7'
                    } else if(componentInfo.src.includes('policy.png')) {
                        componentInfo.color = '#BB94BF'
                    } else if(componentInfo.src.includes('aggregate.png')) {
                        componentInfo.color = '#F8D454'
                    } else if(componentInfo.src.includes('external.png')) {
                        componentInfo.color = '#ED73B6'
                    } else if(componentInfo.src.includes('view.png')) {
                        componentInfo.color = '#5FC08B'
                    } else if(componentInfo.src.includes('issue.png')) {
                        componentInfo.color = '#8E24AA'
                    }
                }

                if (componentInfo.isRelation && componentInfo.component.includes('relation')) {
                    /* make Relation */
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.sourceElement.value,
                        componentInfo.targetElement.value,
                        componentInfo.vertices,
                    );
                } else if(componentInfo.component.includes('line')) {
                    var vertices = [[componentInfo.x, componentInfo.y], [componentInfo.x+200, componentInfo.y]]
                    vertices = JSON.stringify(vertices)

                    /* make Line Element */
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        vertices
                    );

                } else if(componentInfo.component.includes('text')) {
                    /* make Text Element */
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.x,
                        componentInfo.y,
                        componentInfo.width,
                        componentInfo.height,
                    );

                } else {
                    /* make Element */
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.x,
                        componentInfo.y,
                        me.$store.getters.getWidth(componentInfo.component),
                        me.$store.getters.getHeight(componentInfo.component),
                        componentInfo.description,
                        componentInfo.color
                    );
                }

                me.addElementPush(element)
            },
            async purchaseItemDialogSubmit(result) {
                var me = this
                try {
                    if (result) {
                        var returnResult = false
                        var type = me.purchaseItemDialogInfo.resourceType
                        if (type == 'codeView') {
                            returnResult = await me.codeModalShow()
                        } else if (type == 'downloadCode') {
                            returnResult = await me.generateZip()
                        }

                        // console.log('returnResult', returnResult)
                        if (returnResult) {
                            alert(`'${type}' 를 성공 하였습니다.`)
                        } else if (returnResult == false) {
                            // console.log('fail: ', me.purchaseItemDialogInfo)
                            me.purchaseItemDialogClose(false)
                            alert(`'${type}' 를 실패 하였습니다.`)
                        }
                    } else {
                        alert('결제를 실패했습니다.')
                    }
                    me.purchaseItemDialogClose()
                } catch (e) {
                    me.purchaseItemDialogClose()
                }
            }
            ,
            diff_lineMode(text1, text2) {
                var dmp = new DiffMatchPatch();
                var a = dmp.diff_linesToChars_(text1, text2);
                var lineText1 = a.chars1;
                var lineText2 = a.chars2;
                var lineArray = a.lineArray;
                var diffs = dmp.diff_main(lineText1, lineText2, false);
                dmp.diff_charsToLines_(diffs, lineArray);
                return diffs;
            }
            ,
            onConnectShape: function (edge, from, to) {
                var me = this;
                //존재하는 릴레이션인 경우 (뷰 ��포넌트), 데이터 매핑에 의해 자동으로 from, to 가 변경되어있기 때문에 따로 로직은 필요없음.
                //=> 바뀌어야 함.
                //신규 릴레이션인 경우에는 릴레이션 생성
                var edgeElement, originalData;
                var isComponent = false;
                if (edge.shape) {
                    edgeElement = edge;
                }
                // else {
                //     isComponent = true;
                //     edgeElement = edge.element;
                // }

                if (edgeElement && from && to) {
                    var vertices = '[' + edgeElement.shape.geom.vertices.toString() + ']';
                    var componentInfo = {
                        component: 'sticky-note-relation',
                        sourceElement: from.$parent,
                        targetElement: to.$parent,
                        vertices: vertices,
                        isFilled: true,
                        isRelation: true,
                        relationView: {
                            style: JSON.stringify({}),
                            value: vertices,
                        }
                    }

                    from.$parent.value.elementView.id = from.id;
                    to.$parent.value.elementView.id = to.id;

                    // if (isComponent) {
                    //     me.canvas.removeShape(edgeElement, true);
                    //     //this.removeComponentByOpenGraphComponentId(edgeElement.id);
                    //     //기존 컴포넌트가 있는 경우 originalData 와 함께 생성
                    //
                    //     if (me.connectableType(componentInfo.sourceElement.value, componentInfo.targetElement.value))
                    //         this.addElement(componentInfo)
                    // } else {
                    me.canvas.removeShape(edgeElement, true);
                    //기존 컴포넌트가 없는 경우 신규 생성
                    // if (me.connectableType(componentInfo.sourceElement.value, componentInfo.targetElement.value))
                        this.addElement(componentInfo);
                    // }
                }
            },
            filterProjectName(projectName) {
                var filterName = ''
                var pattern1 = /[0-9ㄱ-ㅎ|ㅏ-ㅣ|가-힣~!@#$%^&*()_+|<>?:{}]/gi; // 영어 소문자

                if (projectName) {
                    // filterName = projectName.replace(/\s/gi, "");
                    filterName = projectName
                    if (pattern1.test(filterName)) {
                        filterName = filterName.replace(pattern1, '');
                    }
                    filterName = filterName.toLowerCase()
                    return filterName
                }
                return filterName
            }
            ,
            getCode(path) {
                var me = this
                return new Promise(async function (resolve, reject) {
                    var getCodeUrl = await me.getURL(`cluster://${me.myId.split('@')[1].split('.')[0].toLowerCase()}/classes/running/users/labs/${me.myId}/${me.$route.params.projectId}/` + path, 'eventstorming')

                    me.$http.get(getCodeUrl).then(function (data) {
                        if (path.includes("BoundedContext356"))
                            console.log(data)
                        resolve(data.data)
                    }).catch((e) => {
                        if (path.includes("BoundedContext356"))
                            console.log(e)
                        resolve(null)
                    })
                    // var result = await me.getString(`cluster://${me.myId.split('@')[1].split('.')[0].toLowerCase()}/classes/running/users/labs/${me.myId}/${me.$route.params.projectId}/` + path, 'eventstorming');
                    // resolve(getCodeUrl)
                })
            }
            ,
            getComponentByClassName: function (className) {
                var componentByClassName;
                var me = this

                if (me.isHexagonalModeling) {
                    className = `${className}Hexagonal`
                    $.each(window.Vue.hexagonalModelingComponents, function (i, component) {
                        if (component.default.computed && component.default.computed.className && component.default.computed.className() == className) {
                            componentByClassName = component.default;
                        }
                    });
                } else {
                    $.each(window.Vue.stickyModelingComponents, function (i, component) {
                        if (component.default.computed && component.default.computed.className && component.default.computed.className() == className) {
                            componentByClassName = component.default;
                        }
                    });
                }

                return componentByClassName;
            }
            ,
            changeUrl(state, title, url) {
                if (typeof (history.pushState) != "undefined") { //브라우저가 지원하는 경우
                    history.pushState(state, title, url);
                } else {
                    location.href = url; //브라우저가 지원하지 않는 경우 페이지 이동처리
                }
            }
            ,
            tokenSave() {
                var me = this
                localStorage.setItem('kubernetesToken', me.kubernetesToken);
                localStorage.setItem('clusterAddress', me.clusterAddress);
                me.tokenDialog = false
            }
            ,
            logEvent(event) {
                console.log('Event : ', event);
            }
            ,
            onError(error, stream) {
                console.log('On Error Event', error, stream);
            }
            ,
            applyChange(target, source, change) {
                if (typeof change === 'undefined' && source && ~validKinds.indexOf(source.kind)) {
                    change = source;
                }
                if (target && change && change.kind) {
                    var it = target,
                        i = -1,
                        last = change.path ? change.path.length - 1 : 0;
                    while (++i < last) {
                        if (typeof it[change.path[i]] === 'undefined') {
                            it[change.path[i]] = (typeof change.path[i + 1] !== 'undefined' && typeof change.path[i + 1] === 'number') ? [] : {};
                        }
                        it = it[change.path[i]];
                    }
                    switch (change.kind) {
                        case 'A':
                            if (change.path && typeof it[change.path[i]] === 'undefined') {
                                it[change.path[i]] = [];
                            }
                            applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
                            break;
                        case 'D':
                            delete it[change.path[i]];
                            break;
                        case 'E':
                        case 'N':
                            it[change.path[i]] = change.rhs;
                            break;
                    }
                }
            }
            ,
            difference(object, base) {
                function changes(object, base) {
                    return _.transform(object, function (result, value, key) {
                        if (!_.isEqual(value, base[key])) {
                            result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                        }
                    });
                }

                return changes(object, base);
            }
            ,

            showReplay() {
                var me = this
                if (false) {
                    alert('준비중 입니다.')
                } else {
                    var proId = me.information.projectId ? me.information.projectId : me.params.projectId
                    var author = me.information.author ? me.information.author : me.params.userUid
                    let route = me.$router.resolve({path: `/replay/${proId}/last/last`});
                    window.open(route.href, '_blank');
                }

            }
            ,
            async functionSelect(title) {
                var me = this
                if (title == 'Save to Server') {
                    if (me.isClazzModeling) {
                        me.uploadMinio();
                    } else {
                        me.saveComposition('save')
                    }
                } else if (title == 'Duplicate') {
                    me.saveComposition('duplicate')
                    // me.storageDialogReady('duplicate')
                } else if (title == 'Download model File') {
                    me.downloadModelToJson()
                } else if (title == 'Code Preview') {
                    me.codeModalShow()
                } else if (title == 'Download Archive') {
                    me.generateZipDialog = true
                } else if (title == 'Share') {
                    // me.openEventShareDialog()
                    me.openInviteUsers()
                } else if (title == 'Project IDE') {
                    if (me.isLogin) {
                        var idePrice = await this.getString(`db://pricing/ide`)
                        if (!idePrice) idePrice = 1000
                        if (me.getUserToolTime > 0) {
                            me.openProjectIDE()
                        } else if (me.getUserCoin >= idePrice / 100) {
                            me.$EventBus.$emit('autoToolPay')
                            me.openProjectIDE()
                        } else {
                            me.$EventBus.$emit('openPaymentTime', true)
                        }


                        // if (me.getUserToolTime > 0) {
                        // me.ideStartValidation()
                        // Todo: 파일을 변경 할 것 인지 체크 후 띄우기
                        // } else {
                        //     this.$EventBus.$emit('openPaymentTime', true)
                        // }
                    } else {
                        me.$EventBus.$emit('showLoginDialog')

                    }

                }
            },
            _isAttached(outer, inner) {
                if (
                    //왼쪽 상단 모서리에 걸린 경우
                    (outer.x < inner.x + inner.width &&
                        outer.y < inner.y + inner.height)

                    &&

                    //우측 하단 모서리에 걸린 경우
                    (inner.x < outer.x + outer.width &&
                        inner.y < outer.y + outer.height)

                    &&

                    //오른쪽 상단 모서리에 걸린 경우
                    (inner.x < outer.x + outer.width &&
                        outer.y < inner.y + inner.height)

                    &&

                    //왼쪽 하단 모서리에 걸린 경우
                    (outer.x < inner.x + inner.width &&
                        inner.y < outer.y + outer.height)
                ) return true;

                return false;
            }
            ,
            hashCode(s) {
                return s.split("").reduce(function (a, b) {
                    a = ((a << 5) - a) + b.charCodeAt(0);
                    return a & a
                }, 0);
            }
            ,
            ajax: function (url, method, payload, successCallback) {
                var xhr = new XMLHttpRequest();
                xhr.open(method, url, true);
                // xhr.withCredentials = true;
                xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState != 4 || xhr.status != 200) return;
                    successCallback(xhr.responseText);
                };
                xhr.send(JSON.stringify(payload));
            },
            b64toBlob: function (b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }
            ,
            
        }
    }
</script>

<style>
    @media only screen and (max-width: 781px) {

        #mobile-undo-redo {
            margin-left: 20px;
        }

        #project-name {
            position: absolute;
        }

        #action-btn {
            position: absolute;
            right: 0;
        }

        #mobile-action-btn {
            position: relative;
            right: 5px;
            bottom: -10px;
        }
    }

    #mobile-menu-popup-btn {
        position: absolute;
        right: 0;
        bottom: 0;
    }

    #mobile-menu-popup-btn .v-speed-dial {
        position: absolute;
    }

    #mobile-menu-popup-btn .v-btn--floating {
        position: relative;
    }

    .codeModal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 10; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

</style>